import React from "react";
import { Close, Header, Modal } from "MODULES/shared/components/Modal";
import T from "prop-types";
import Body from "MODULES/shared/components/Modal/Body";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";

function Submitted({ open, close, logoUrl }) {
  return (
    <Modal open={open} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Password Reset</h4>
        <Body>
          <FormRow>
            <Col md={12}>
              <div className="text-center">
                {logoUrl && (
                  <img
                    src={logoUrl}
                    alt="Logo"
                    height="50px"
                    style={{ marginBottom: 20 }}
                  />
                )}
              </div>
              <div className="well well-lg">
                If we found an account associated with that email address, you
                will find an email from us in your inbox shortly.
              </div>
            </Col>
          </FormRow>
        </Body>
      </Header>
    </Modal>
  );
}

Submitted.propTypes = {
  close: T.func,
  open: T.bool.isRequired,
  logoUrl: T.string
};

export default Submitted;



// WEBPACK FOOTER //
// ./app/modules/session/components/ForgotPassword/Submitted.jsx